export default __webpack_public_path__ + "static/media/web2_dev.fe9ffb13.svg";